exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_wks-ext.js
// module id = EUbi
// module chunks = 0